import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mb-32"
}
const _hoisted_2 = { class: "flex flex--wrap flex--justify-space-between mb-32" }
const _hoisted_3 = { class: "a7-12 f6-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "form__label" }, " Jump to section: ", -1 /* HOISTED */)
const _hoisted_5 = { class: "flex flex--column-gap-large flex--row-gap-medium flex--wrap" }
const _hoisted_6 = { class: "a5-12 f6-6 flex flex--gap-medium flex--justify-end flex--align-center" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", {
  id: "virtual-tour",
  class: "h4"
}, " Virtual Tour ", -1 /* HOISTED */)
const _hoisted_9 = { class: "grid grid--xs flex flex--wrap mb-56" }
const _hoisted_10 = { class: "grid__item a2-12 mb-24" }
const _hoisted_11 = { class: "image-grid-card__image-wrapper" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 1,
  class: "image-grid-card__image image-grid-card__image--default"
}
const _hoisted_14 = { class: "image-grid-card__title" }
const _hoisted_15 = { class: "image-grid-card__details-container" }
const _hoisted_16 = {
  key: 0,
  class: "image-grid-card__details"
}
const _hoisted_17 = { class: "image-grid-card__details-icons" }
const _hoisted_18 = {
  key: 0,
  class: "image-grid-card__comments"
}
const _hoisted_19 = { class: "image-grid-card__comment-count" }
const _hoisted_20 = {
  key: 0,
  class: "image-grid-card__asset-status"
}
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", {
  id: "animations",
  class: "h4"
}, " Animation from Virtual Tour ", -1 /* HOISTED */)
const _hoisted_23 = { class: "grid grid--xs flex flex--wrap mb-56" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "image-grid-card__image-wrapper" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = {
  key: 1,
  class: "image-grid-card__image image-grid-card__image--default"
}
const _hoisted_28 = { class: "image-grid-card__info" }
const _hoisted_29 = { class: "image-grid-card__title" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", {
  id: "stills",
  class: "h4"
}, " Stills from Virtual Tour ", -1 /* HOISTED */)
const _hoisted_31 = { class: "grid grid--xs flex flex--wrap mb-56" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "image-grid-card__image-wrapper" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = {
  key: 1,
  class: "image-grid-card__image image-grid-card__image--default"
}
const _hoisted_36 = { class: "image-grid-card__info" }
const _hoisted_37 = { class: "image-grid-card__title" }
const _hoisted_38 = ["aria-label", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_router_link = _resolveComponent("router-link")
  const _component_GalleryModalComponent = _resolveComponent("GalleryModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "back-to mb-32",
                onClick: _cache[0] || (_cache[0] = (...args) => ($options.goBackToMainGrid && $options.goBackToMainGrid(...args)))
              }, " Back to main grid "),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      key: "jump-to-virtual-tour",
                      class: "p--small a a--underline",
                      onClick: _cache[1] || (_cache[1] = $event => ($options.scrollTo( 'virtual-tour' )))
                    }, " Virtual Tour Asset "),
                    ($options.animations.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: "jump-to-animations",
                          class: "p--small a a--underline",
                          onClick: _cache[2] || (_cache[2] = $event => ($options.scrollTo( 'animations' )))
                        }, " Animation "))
                      : _createCommentVNode("v-if", true),
                    ($options.stills.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: "jump-to-stills",
                          class: "p--small a a--underline",
                          onClick: _cache[3] || (_cache[3] = $event => ($options.scrollTo( 'stills' )))
                        }, " Stills "))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "p--small a a--underline",
                    onClick: _cache[4] || (_cache[4] = (...args) => ($options.toggleAllChecked && $options.toggleAllChecked(...args)))
                  }, _toDisplayString($options.everything_checked ? 'Deselect all' : 'Select all'), 1 /* TEXT */),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button button--fill", { 'button--loading': $data.loading_download }]),
                    disabled: $options.nothing_checked,
                    onClick: _cache[5] || (_cache[5] = (...args) => ($options.downloadSelectedLatestOptions && $options.downloadSelectedLatestOptions(...args)))
                  }, " Download selected ", 10 /* CLASS, PROPS */, _hoisted_7)
                ])
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: {
							name: 'projects__project__asset',
							params: {
								project_id: _ctx.$route.params.project_id,
								asset_id: $props.asset.id
							}
						},
                    class: _normalizeClass(["image-grid-card", { 'image-grid-card--greyed-out': $props.asset.asset_status && ['paused', 'cancelled'].includes( $props.asset.asset_status ) }])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        ($props.asset.featured_image_small.url)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: $props.asset.featured_image_small.url,
                              alt: $props.asset.featured_image_small.alt_text,
                              class: "image-grid-card__image"
                            }, null, 8 /* PROPS */, _hoisted_12))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13))
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["image-grid-card__info", { 'image-grid-card__info--with-revision': $props.asset.last_revision }])
                      }, [
                        _createElementVNode("p", _hoisted_14, _toDisplayString($props.asset.title), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_15, [
                          ($props.asset.last_revision)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
												'image-grid-card__stage',
												$options.getRevisionPipClass( $props.asset.last_revision )
											])
                                  }, _toDisplayString($props.asset.last_revision.revision_number), 3 /* TEXT, CLASS */),
                                  ($props.unreadCommentCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                        _createElementVNode("span", _hoisted_19, _toDisplayString($props.unreadCommentCount), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                ($props.asset.asset_status && ['paused', 'cancelled'].includes( $props.asset.asset_status ))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($props.asset.asset_status === 'paused' ? '[Paused]' : '[Cancelled]'), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 2 /* CLASS */),
                      ($props.asset.featured_image_small.url)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "image-grid-card__fullscreen",
                            "aria-label": "View image fullscreen",
                            onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.openAssetGallery && $options.openAssetGallery(...args)), ["prevent"]))
                          }))
                        : _createCommentVNode("v-if", true),
                      ($props.asset.media_type[0].base_type === 'image' && $props.asset.featured_image_small.url)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass(["image-grid-card__checkbox", { 'image-grid-card__checkbox--checked': _ctx.checked_assets.includes( $props.asset.id ) }]),
                            "aria-label": _ctx.checked_assets.includes( $props.asset.id ) ? `Select asset's images for download` : `Deselect asset's images for download`,
                            onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.asset_checked = !_ctx.asset_checked), ["prevent"]))
                          }, null, 10 /* CLASS, PROPS */, _hoisted_21))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to", "class"])
                ])
              ]),
              ($options.animations.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.animations, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'animation-' + option.id,
                          class: "grid__item a2-12 mb-24"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["image-grid-card image-grid-card--shadowless", { 'image-grid-card--click': option.video_url }]),
                            onClick: _withModifiers($event => (option.video_url ? $options.openAnimationsGallery( option.id ) : null), ["prevent"])
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              (option.thumbnail_url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: option.thumbnail_url,
                                    alt: option.title,
                                    class: "image-grid-card__image"
                                  }, null, 8 /* PROPS */, _hoisted_26))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27))
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(option.title), 1 /* TEXT */)
                            ])
                          ], 10 /* CLASS, PROPS */, _hoisted_24)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($options.stills.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stills, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'animation-' + option.id,
                          class: "grid__item a2-12 mb-24"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["image-grid-card image-grid-card--shadowless", { 'image-grid-card--click': option.image_small_url }]),
                            onClick: _withModifiers($event => (option.image_small_url ? $options.openStillsGallery( option.id ) : null), ["prevent"])
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              (option.image_small_url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: option.image_small_url,
                                    alt: option.title,
                                    class: "image-grid-card__image"
                                  }, null, 8 /* PROPS */, _hoisted_34))
                                : (_openBlock(), _createElementBlock("div", _hoisted_35))
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("p", _hoisted_37, _toDisplayString(option.title), 1 /* TEXT */)
                            ]),
                            (option.image_original_url || option.image_large_url)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["image-grid-card__checkbox", { 'image-grid-card__checkbox--checked': $data.checked_options.includes( option.id ) }]),
                                  "aria-label": $data.checked_options.includes( option.id ) ? `Select asset's images for download` : `Deselect asset's images for download`,
                                  onClick: _withModifiers($event => ($options.toggleOptionCheck( option.id )), ["stop"])
                                }, null, 10 /* CLASS, PROPS */, _hoisted_38))
                              : _createCommentVNode("v-if", true)
                          ], 10 /* CLASS, PROPS */, _hoisted_32)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
      ]),
      _: 1 /* STABLE */
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.gallery_options && $data.gallery_options.length && $data.show_gallery_modal)
            ? (_openBlock(), _createBlock(_component_GalleryModalComponent, {
                key: 0,
                options: $data.gallery_options,
                onCloseModal: $options.closeGalleryModal
              }, null, 8 /* PROPS */, ["options", "onCloseModal"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}